import { render, staticRenderFns } from "./FileUploadV2.vue?vue&type=template&id=19bfba7c&scoped=true&"
import script from "./FileUploadV2.vue?vue&type=script&lang=js&"
export * from "./FileUploadV2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19bfba7c",
  null
  
)

export default component.exports